import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-dod-notice-and-consent-banner-dialog',
  templateUrl: './dod-notice-and-consent-banner-dialog.component.html',
  styleUrls: ['./dod-notice-and-consent-banner-dialog.component.scss']
})
export class DodNoticeAndConsentBannerDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DodNoticeAndConsentBannerDialogComponent>) { }

  ngOnInit() {
  }

  confirm() {
    this.dialogRef.close(true);
  }

  reject() {
    this.dialogRef.close(false);
  }
}
